function listenCounterCart() {
  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        let counter = 0;
        const allCartItems = document.querySelectorAll('.nova-cart-items-row');
        if (allCartItems.length > 0) {
          allCartItems.forEach((cartItem) => {
            const quantityInputValue = cartItem.querySelector('.quantity__input').value;
            counter += parseInt(quantityInputValue);
          });
        }
        const headerBubble = document.getElementById('cart-icon-bubble-nova-header');
        const mobileBubble = document.getElementById('cart-icon-bubble-nova-mobile-header');

        if (headerBubble) {
          const countElement = headerBubble.querySelector('.cart-icon-bubble-count');
          if (countElement) {
            countElement.textContent = counter;
          }
        }

        if (mobileBubble) {
          const countElement = mobileBubble.querySelector('.cart-icon-bubble-count');
          if (countElement) {
            countElement.textContent = counter;
          }
        }
      }
    });
  });

  const config = {
    childList: true,
    attributes: true,
    subtree: true
  };

  const targetNode = document.getElementById('nova-drawer');

  observer.observe(targetNode, config);
}

window.addEventListener('load', function () { 
  listenCounterCart();
});